export default {
  GETTERS: {
    GET_USER: 'SESSION/GET_USER',
    GET_USER_ADDRESS: 'SESSION/GET_USER_ADDRESS',
    GET_IS_SIGNED_IN: 'SESSION/GET_IS_SIGNED_IN',
    GET_AUTHENTICITY_TOKEN: 'SESSION/GET_AUTHENTICITY_TOKEN'
  }
}
